import type {
    Editable,
    HTML5MasterTemplate,
    OverwriteMediaItem,
    ResizeSettings,
} from "hoxton-types";

import { constructCoverUrl } from "./templateCover";
import objectIdsMatch from "./objectIdsMatch";

export default function getMediaItemResizedUrl({
    editable: { defaultValues },
    mediaItem: { url, resizeSettings },
    masterTemplate,
    renderService,
}: {
    editable: Editable;
    mediaItem: OverwriteMediaItem;
    masterTemplate: HTML5MasterTemplate | null | undefined;
    renderService: string;
}) {
    const defaultValue = defaultValues.find((value) =>
        objectIdsMatch(value.masterTemplateId, masterTemplate?._id),
    );

    if (!defaultValue || !resizeSettings) {
        return url;
    }

    let settings: ResizeSettings;

    if ("resizeSettingsByTemplateId" in resizeSettings) {
        if (
            masterTemplate?._id &&
            (resizeSettings as { resizeSettingsByTemplateId: Record<string, ResizeSettings> })
                .resizeSettingsByTemplateId?.[masterTemplate?._id]
        ) {
            settings = (
                resizeSettings as {
                    resizeSettingsByTemplateId: Record<string, ResizeSettings>;
                }
            ).resizeSettingsByTemplateId[masterTemplate?._id];
        } else {
            settings = {} as ResizeSettings;
        }
    } else {
        settings = resizeSettings;
    }

    // Make sure we are on BE when we use this. On the FE in the editor we can load from the image service
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    if (typeof window === "undefined" && "persistentKey" in settings && settings.persistentKey) {
        return settings.persistentKey;
    }

    const { dimensions } = defaultValue;
    const { cover, manualSettings } = settings;

    if (!dimensions || (!cover && !manualSettings)) {
        return url;
    }

    return constructCoverUrl({
        imageUrlToResize: url,
        manualSettings,
        renderService,
    });
}
